import { List } from 'immutable'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getValue, option } from '../../../lib/common'
import { PortalCreatableSelect } from '../../Main/SelectControls'
import { getProjectMappingElements } from '../../../lib/project'

export const FOCUS_BY = { STATIC: 'static', FIELD: 'field' }

const TYPES = [option('Field', 'field'), option('Static', 'static')]

export default function FocusByPin({ settings, onChange, pageUID, pageID }) {
  const mappingElements = useSelector((state) => getProjectMappingElements(state, true))

  return (
    <div className="form-group">
      <label className="form-label">Select Pin By Value</label>
      <div className="gray-input white-select flex-group">
        <div className="ft--email--mapfld" style={{ width: 258 }}>
          <PortalCreatableSelect
            options={TYPES}
            isElementStyle={true}
            value={getValue(TYPES, settings.getIn(['focusOn', 'pinValue', 'type'], 'static'))}
            onChange={(value) => onChange(['focusOn', 'pinValue', 'type'], value.value)}
          />
        </div>

        <div className="ft--email--mapfld-value">
          {settings.getIn(['focusOn', 'pinValue', 'type'], 'static') === 'field' && (
            <PortalCreatableSelect
              options={mappingElements}
              isElementStyle={true}
              value={getValue(mappingElements, settings.getIn(['focusOn', 'pinValue', 'field']))}
              onChange={(value) => onChange(['focusOn', 'pinValue', 'field'], value.value)}
            />
          )}
          {settings.getIn(['focusOn', 'pinValue', 'type'], 'static') === 'static' && (
            <input
              type="text"
              className="white-box-input ft--has-icon"
              value={settings.getIn(['focusOn', 'pinValue', 'textValue'], '')}
              onChange={(evt) => onChange(['focusOn', 'pinValue', 'textValue'], evt.target.value)}
              placeholder="Static Value"
            />
          )}
        </div>
      </div>
    </div>
    // <div className="predefined-page-list form-group">
    //     <label className="field-label">Select Pin</label>
    //     <PortalCreatableSelect
    //         options={pinsMemo}
    //         menuPortalTarget={document.body}
    //         isElementStyle={true}
    //         styles={{
    //             indicatorsContainer: {
    //                 height: '32px'
    //             }
    //         }}
    //         value={getValue(pinsMemo, settings.getIn(['focusOn', 'pin', 'value']))}
    //         isSearchable
    //         onChange={onChange}
    //     />
    // </div>
  )
}
